export function findAIProofreaderPricing(APIResponse) {
    return APIResponse.find((el) => el.service.name === 'ai_proofreader') || null;
}
